import { NgModule } from "@angular/core";
import { AppRepository } from "./app.repository";
import { AuthRepository } from "./auth/auth.repository";
import { UserRepository } from "./user/user.repository";
import { ActiveFormRepository } from "./activeForm.repository";
import { ProjectsRepository } from "./projects.repository";
import { ProjectsRepository as ProjectsV2Repository } from "./v2/projects.repository";
import { ProviderModule } from "../providers/provider.module";
import { AppConfigActions } from "../states/app";
import { ActiveFormActions } from "../states/activeForm";
import { ProjectsActions } from "../states/projects";
import { ProjectsActions as ProjectsV2Actions } from "../states/v2/projects";

@NgModule({
  declarations: [],
  imports: [ProviderModule],
  providers: [
	AppRepository,
	AuthRepository,
	UserRepository,
	ActiveFormRepository,
	ProjectsRepository,
	ProjectsV2Repository,
	AppConfigActions,
	ActiveFormActions,
	ProjectsActions,
	ProjectsV2Actions,
  ]
})
export class RepositoryModule {}



// WEBPACK FOOTER //
// ./src/repositories/repository.module.ts